var _circle, _circle2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.6667,
    stroke: "black",
    strokeOpacity: 0.15,
    strokeWidth: 0.666667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0382 9.15801H6.14411C5.88529 9.15801 5.67157 9.08354 5.50294 8.9346C5.33431 8.78565 5.25 8.58575 5.25 8.33489C5.25 8.08403 5.33431 7.88217 5.50294 7.7293C5.67157 7.57643 5.88529 7.5 6.14411 7.5H18.0382C18.2971 7.5 18.5088 7.57643 18.6736 7.7293C18.8382 7.88217 18.9205 8.08403 18.9205 8.33489C18.9205 8.58575 18.8382 8.78565 18.6736 8.9346C18.5088 9.08354 18.2971 9.15801 18.0382 9.15801Z",
    fill: "black",
    fillOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0382 13.0503H6.14411C5.88529 13.0503 5.67157 12.9758 5.50294 12.8268C5.33431 12.6779 5.25 12.478 5.25 12.2271C5.25 11.9762 5.33431 11.7744 5.50294 11.6215C5.67157 11.4686 5.88529 11.3922 6.14411 11.3922H18.0382C18.2971 11.3922 18.5088 11.4686 18.6736 11.6215C18.8382 11.7744 18.9205 11.9762 18.9205 12.2271C18.9205 12.478 18.8382 12.6779 18.6736 12.8268C18.5088 12.9758 18.2971 13.0503 18.0382 13.0503Z",
    fill: "black",
    fillOpacity: 0.85
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0382 16.9543H6.14411C5.88529 16.9543 5.67157 16.8778 5.50294 16.7249C5.33431 16.572 5.25 16.3741 5.25 16.1311C5.25 15.8803 5.33431 15.6784 5.50294 15.5255C5.67157 15.3726 5.88529 15.2962 6.14411 15.2962H18.0382C18.2971 15.2962 18.5088 15.3726 18.6736 15.5255C18.8382 15.6784 18.9205 15.8803 18.9205 16.1311C18.9205 16.3741 18.8382 16.572 18.6736 16.7249C18.5088 16.8778 18.2971 16.9543 18.0382 16.9543Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileExpand);
export default __webpack_public_path__ + "static/media/mobile-expand.ad16186865e1665fbbc7cbbde47fd786.svg";
export { ForwardRef as ReactComponent };